import { Component, OnInit } from '@angular/core';

import { AuthenticationService } from '../../login/authentication.service'

import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { GetparticipantService } from '../participantedit/getparticipant.service';

import { MenutitleService } from '../../../shared/menutitle.service';
import { ShowmenuService } from '../../../shared/showmenu.service';

import { MenucontentService } from '../../../shared/menucontent.service';

@Component({
  selector: 'app-participantkeyboard',
  templateUrl: './participantkeyboard.component.html',
  styleUrls: ['./participantkeyboard.component.css'],
})
export class ParticipantkeyboardComponent implements OnInit {
  qrForm: UntypedFormGroup;
  loading = false;
  submitted = false;
  //error = '';

  showmenu: boolean;

  gotoQRcode() {
    this.router.navigate(['/participantscan']);
  }

  onSubmit() {
    this.submitted = true;

    if (!this.qrForm.valid) {
      return;
    }

    this.loading = true;

    this.GetparticipantService.getparticipant(
      this.qrForm.controls.qrnumber.value
    )
      .pipe(first())
      .subscribe({
        next: () => {
          // get return url from route parameters or default to '/'
          //const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
          //this.router.navigate([returnUrl]);
          //this.showmenu.changeShowmenu(true);
          this.router.navigate([
            '/participantedit',
            this.qrForm.controls.qrnumber.value,
          ]);
        },
        error: (error) => {
          //this.error = error;
          //this.loading = false;
          //alert(error);
          this.router.navigate([
            '/participantedit',
            this.qrForm.controls.qrnumber.value,
          ]);
        },
      });
  }

  constructor(
    private menutitle: MenutitleService,
    private AuthenticationService: AuthenticationService,
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private GetparticipantService: GetparticipantService,
    private ShowmenuService: ShowmenuService,
    private MenucontentService: MenucontentService
  ) {}

  ngOnInit(): void {
    this.AuthenticationService.check_logged_in()
    this.AuthenticationService.save_current_route()
    
    this.ShowmenuService.changeShowmenu(true);
    this.MenucontentService.changeMenuMassStart();
    this.MenucontentService.changeMenuIndividualStart();
    this.MenucontentService.changeCheckpoints();

    this.menutitle.changeMenutitle('Manage Participants');
    this.menutitle.showMenupink(false);

    this.qrForm = this.formBuilder.group({
      qrnumber: ['', [Validators.required]],
    });

    localStorage.setItem('global_input_method', 'keyboard');
  }
}
